// extracted by mini-css-extract-plugin
export var elevatedFrame = "_0-2";
export var elevatedShell = "_0-1";
export var shell = "_0-0";